import { createContext } from 'react';

export type FolioOpenReason = 'user' | 'bootstrap';

export interface FolioToggleContextValue {
  readonly isOpen: boolean;
  readonly openReason: FolioOpenReason;
  /**
   * Answers a press on Sean's button or shortcut, begun at `pressedAt` (an
   * event timestamp): shows Sean, or hides it. A press that began before Sean
   * opened itself, or while it was still sliding in, was aimed at the closed
   * panel, so it keeps Sean open rather than hiding what the user asked for.
   */
  readonly toggle: (pressedAt: number) => void;
  /**
   * Shows Sean. With `bootstrap`, Sean opens itself, which it does only while
   * the panel is closed and the user has not yet shown or hidden it.
   */
  readonly open: (reason?: FolioOpenReason) => void;
  readonly close: () => void;
}

export const FolioToggleContext = createContext<FolioToggleContextValue | null>(null);
